// extracted by mini-css-extract-plugin
export var quillEditor = "_lx-1";
export var variable = "_lx-0";